module.exports = __webpack_public_path__ + "img/button-p3=hover.d4512bb4.png";